import React from 'react';
import { CashBack } from '@lt/components';
import { useSelector } from 'react-redux';
import {
  getActivateCashbackForPartner,
  getCashbackLabel,
  getCashbackTooltip,
  getCustomCashbackIconUrl,
  getIsMobile,
} from 'src/store/view/selectors';
import { bonusesByTourIdSelector } from '../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { calculateCashback } from '../../utils/orderUtils';

interface FlightCashbackProps {
  fullPrice: number;
  tourId: string;
}

const FlightCashback = ({ fullPrice, tourId }: FlightCashbackProps) => {
  const customCashbackIconURL = useSelector(getCustomCashbackIconUrl);
  const customCashbackText = useSelector(getCashbackLabel);
  const customCashbackTooltipText = useSelector(getCashbackTooltip);
  const activateCashbackForPartner = useSelector(getActivateCashbackForPartner);
  const isMobile = useSelector(getIsMobile);
  const cashbackParams = useSelector((state) =>
    bonusesByTourIdSelector(state, tourId),
  );

  const value = activateCashbackForPartner
    ? calculateCashback(cashbackParams, fullPrice)
    : 0;

  if (!value) {
    return null;
  }

  return (
    <CashBack
      customCashbackIconURL={customCashbackIconURL}
      customCashbackText={customCashbackText}
      customCashbackTooltipText={customCashbackTooltipText}
      count={`+${value}`}
      cashbackText
      isMobile={isMobile}
      // @ts-ignore
      type={cashbackParams.cashbackIdentifier}
    />
  );
};

export default FlightCashback;
